module.exports = __webpack_public_path__ + "img/Yoga3.67890ad8.png";